<template>
  <Card class="m-3">
    <template #title="">Performance Report</template>
    <template #content="">
      <div class="formgrid grid">
        <div class="col-12 md:col-4 lg:col-3 p-fluid field">
          <label for="selectedDate">ระบุวันที่รายงาน</label>
          <Calendar id="selectedDate" v-model="screen.selectedDate"></Calendar>
        </div>
        <div class="col-12 md:col-4 lg:col-3 p-fluid field">
          <label for="salesOffice">ระบุ Sales Office</label>
          <MultiSelect
            v-model="screen.salesOffices"
            :options="salesOffices"
            optionLabel="description"
            optionValue="code"
          ></MultiSelect>
        </div>
        <div
          class="
            col-12
            md:col-4
            lg:col-3
            flex flex-column
            justify-content-end
            field
          "
        >
          <Button
            icon="pi pi-search"
            @click="queryReport"
            :loading="isLoading"
          ></Button>
        </div>
      </div>
      <div class="grid">
        <div class="col-12">
          <!-- <DataTable :value="results">
            <template #empty="">ไม่พบข้อมูล</template>
            <Column field="shipmentNo" header="Shipment No"></Column>
            <Column field="driver" header="Driver"></Column>
            <Column field="driverName" header="Driver Name"></Column>
            <Column field="startTime" header="Start Time">
              <template #body="props">
                {{ props.data.startTime.hours }} :
                {{ props.data.startTime.minutes }}
              </template>
            </Column>
            <Column field="endTime" header="End Time">
              <template #body="props">
                {{ props.data.endTime.hours }} :
                {{ props.data.endTime.minutes }}
              </template>
            </Column>
            <Column field="duration" header="Duration"></Column>
            <Column field="docAssign" header="Doc Assign"></Column>
            <Column field="docSuccess" header="Doc Success"></Column>
            <Column field="caseAssign" header="Case Assign"></Column>
            <Column field="caseSuccess" header="Case Success"></Column>
            <Column field="customers" header="Customers"></Column>
            <Column field="capacity" header="Capacity"></Column>
            <Column field="capacityPercent" header="Capacity Percent"></Column>
            <Column field="capacityAssign" header="Capacity Assign"></Column>
            <Column field="helpers" header="Helpers"></Column>
            <Column field="officeCode" header="Office Code"></Column>
            <Column field="office" header="Office"></Column>
          </DataTable> -->
          <DataView :value="filteredResult" layout="grid">
            <template #header="">
              <div class="grid formgrid" v-if="results.length > 0">
                <div class="col-12 md:col-4 xl:col-2 p-fluid field">
                  <span class="p-float-label">
                    <Dropdown
                      v-model="selectedSort"
                      :options="sortOptions"
                      optionValue="code"
                      optionLabel="description"
                      id="sortDropdown"
                      @change="onSelectSort"
                    >
                    </Dropdown>
                    <label for="sortDropdown">Sort by</label>
                  </span>
                </div>
                <div class="col-12 md:col-4 xl:col-2 p-fluid field">
                  <span class="p-float-label">
                    <InputText
                      id="searchString"
                      v-model="searchString"
                      class="p-inputtext-sm"
                    ></InputText>
                    <label for="searchString">ค้นหา</label>
                  </span>
                </div>
              </div>
            </template>
            <template #empty="">ไม่พบข้อมูล</template>
            <template #grid="props">
              <div class="col-12 md:col-6 lg:col-4 xl:col-3 driver-box">
                <div
                  class="
                    m-1
                    p-2
                    border-round border-1 border-orange-500
                    shadow-1
                  "
                >
                  <div class="flex justify-content-between">
                    <span>
                      <b>Shipment No:</b>{{ parseInt(props.data.shipmentNo) }}
                    </span>
                    <span class="detail font-bold">
                      {{ props.data.office }}
                    </span>
                  </div>
                  <div class="detail flex justify-content-between">
                    <span style="font-size: 1rem">
                      {{ parseInt(props.data.driver) }} :
                      {{ props.data.driverName }}
                    </span>
                    <span>
                      {{ props.data.startTime }} - {{ props.data.endTime }}
                    </span>
                  </div>
                  <div class="detail flex justify-content-between">
                    <span>
                      จำนวนเอกสาร : {{ props.data.docSuccess }} /
                      {{ props.data.docAssign }}
                    </span>
                    <span>
                      {{ (props.data.duration / 3600).toFixed(0) }} ชั่วโมง
                      {{ ((props.data.duration % 3600) / 60).toFixed(0) }} นาที
                    </span>
                  </div>
                  <div class="detail flex justify-content-between">
                    <span>
                      จำนวนเคส : {{ props.data.caseSuccess }} /
                      {{ props.data.caseAssign }}
                    </span>
                    <span>จำนวนลูกค้า : {{ props.data.customers }}</span>
                  </div>
                  <div class="detail">Capacity : {{ props.data.capacity }}</div>
                  <div class="detail">
                    Capacity Used : {{ props.data.capacityAssign }} ({{
                      props.data.capacityPercent
                    }}
                    %)
                  </div>
                  <div class="detail">
                    Case/manday :
                    {{
                      formatQuantity(
                        props.data.caseAssign / (props.data.helpers + 1)
                      )
                    }}
                  </div>
                </div>
              </div>
            </template>
            <template #footer="">
              <div class="flex justify-content-between">
                <span>จำนวนเอกสารทั้งหมด {{ results.length }} เอกสาร</span>
                <Button
                  icon="pi pi-download"
                  label="Download Excel"
                  class="p-button-success"
                  @click="downloadExcel"
                  :disabled="results.length === 0"
                ></Button>
              </div>
            </template>
          </DataView>
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts">
import { usePlugin } from "@/plugins";
import {
  FetchPerformanceReportRequest,
  FetchPerformanceReportResponse,
  PerformanceReport,
} from "@/types";
import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { useSessionStorage } from "@vueuse/core";
import Fuse from "fuse.js";

export default defineComponent({
  name: "PerformanceReport",
  setup() {
    const {
      dayjs,
      axios,
      error,
      setLoading,
      formatQuantity,
      numeral,
      information,
      salesOfficesMaster,
      store,
    } = usePlugin();
    // const screen = reactive({
    //   selectedDate: dayjs("02/03/2021").toDate(), //dayjs().toDate(),
    //   salesOffices: ["9201"] as string[],
    // });

    const searchString = ref("");
    const selectedSort = ref("");
    const sortOptions = ref([
      { code: "1", description: "Case/Manday มากไปน้อย" },
      { code: "2", description: "Case/Manday น้อยไปมาก" },
      { code: "3", description: "Capacity Used มากไปน้อย" },
      { code: "4", description: "Capacity Used น้อยไปมาก" },
      { code: "5", description: "Shipment No. มากไปน้อย" },
      { code: "6", description: "Shipment No. น้อยไปมาก" },
      { code: "7", description: "Dman Id มากไปน้อย" },
      { code: "8", description: "Dman Id น้อยไปมาก" },
      { code: "9", description: "จำนวนลูกค้า มากไปน้อย" },
      { code: "10", description: "จำนวนลูกค้า น้อยไปมาก" },
    ]);
    const isLoading = ref(false);

    const filteredResult = computed(() => {
      if (!searchString.value) return results.value;

      const fuse = new Fuse(results.value, {
        keys: ["shipmentNo", "driver", "driverName", "office"],
      });
      const filtered = fuse.search(searchString.value);
      return filtered.map((x) => x.item);
    });
    const onSelectSort = () => {
      switch (selectedSort.value) {
        case "1":
          results.value = results.value.sort(
            (y, x) =>
              x.caseSuccess / (x.helpers + 1) - y.caseSuccess / (y.helpers + 1)
          );
          break;
        case "2":
          results.value = results.value.sort(
            (x, y) =>
              x.caseSuccess / (x.helpers + 1) - y.caseSuccess / (y.helpers + 1)
          );
          break;
        case "3":
          results.value = results.value.sort(
            (y, x) => x.capacityPercent - y.capacityPercent
          );
          break;
        case "4":
          results.value = results.value.sort(
            (x, y) => x.capacityPercent - y.capacityPercent
          );
          break;
        case "5":
          results.value = results.value.sort(
            (y, x) => parseInt(x.shipmentNo) - parseInt(y.shipmentNo)
          );
          break;
        case "6":
          results.value = results.value.sort(
            (x, y) => parseInt(x.shipmentNo) - parseInt(y.shipmentNo)
          );
          break;
        case "7":
          results.value = results.value.sort(
            (y, x) => parseInt(x.driver) - parseInt(y.driver)
          );
          break;
        case "8":
          results.value = results.value.sort(
            (x, y) => parseInt(x.driver) - parseInt(y.driver)
          );
          break;
        case "9":
          results.value = results.value.sort(
            (y, x) => x.customers - y.customers
          );
          break;
        case "10":
          results.value = results.value.sort(
            (x, y) => x.customers - y.customers
          );
          break;
        default:
          break;
      }
    };

    const screen = useSessionStorage("performanceReport-screen", {
      selectedDate: dayjs().toDate(), //dayjs().toDate(),
      salesOffices:
        store.value.salesOfficeAuthority
          ?.split(",")
          ?.map((x) => x.replaceAll(" ", "")) ?? ([] as string[]),
    });

    const salesOffices = ref(
      salesOfficesMaster.filter(
        (x) => store.value.salesOfficeAuthority.indexOf(x.code) >= 0
      )
    );
    const results = ref<PerformanceReport[]>([]);

    const queryReport = async () => {
      isLoading.value = true;
      try {
        const result = await axios.post<FetchPerformanceReportResponse>(
          `api/v1/admin/performanceReport`,
          {
            date: screen.value.selectedDate,
            offices:
              screen.value.salesOffices.length > 0
                ? screen.value.salesOffices.join(",")
                : store.value.salesOfficeAuthority,
          } as FetchPerformanceReportRequest
        );
        results.value = result.data.reports ?? [];
        if (results.value.length === 0) {
          information("ไม่พบข้อมูล กรุณาลองใหม่ในภายหลัง");
        }
      } catch (e) {
        error(e);
      } finally {
        isLoading.value = false;
      }
    };

    const getExcelData = () => {
      return results.value.map((report) => {
        return [
          report.shipmentNo,
          report.driver,
          report.driverName,
          `${numeral(report.startTime.hours).format("00")}:${numeral(
            report.startTime.minutes
          ).format("00")}:${numeral(report.startTime.seconds).format("00")}`,
          `${numeral(report.endTime.hours).format("00")}:${numeral(
            report.endTime.minutes
          ).format("00")}:${numeral(report.endTime.seconds).format("00")}`,
          `${numeral(report.duration / 3600).format("00")}:${numeral(
            (report.duration % 3600) / 60
          ).format("00")}:${numeral(report.duration % 60).format("00")}`,
          report.docAssign,
          (report.docSuccess / report.docAssign) * 100,
          ((report.docAssign - report.docSuccess) / report.docAssign) * 100,
          report.caseSuccess,
          report.caseSuccess / report.customers,
          (report.caseSuccess / report.caseAssign) * 100,
          ((report.caseAssign - report.caseSuccess) / report.caseAssign) * 100,
          report.capacity,
          report.capacityPercent,
          report.helpers,
          report.caseSuccess / (report.helpers + 1),
        ];
      });
    };

    const downloadExcel = async () => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Main");

      const excelData = getExcelData();
      worksheet.addTable({
        name: "ResultTable",
        columns: [
          { name: "Shipment No." },
          { name: "DMan No." },
          { name: "DMan Name" },
          { name: "Start Time" },
          { name: "End Time" },
          { name: "Actual Total Time" },
          { name: "Document Assign" },
          { name: "%Deliver Success" },
          { name: "%Undeliver Success" },
          { name: "Total Cases" },
          { name: "Cases/Drop" },
          { name: "%Case Deliver" },
          { name: "%Case Undelivery" },
          { name: "Truck Capacity (Cube)" },
          { name: "%Cube Used/Trip" },
          { name: "Ratio Helper/Dman" },
          { name: "Case/Man Day" },
        ],
        rows: excelData,
        ref: "A1",
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer]);

      saveAs(blob, "test.xlsx");
    };

    onMounted(() => {
      screen.value.selectedDate = dayjs(screen.value.selectedDate).toDate();
    });

    return {
      screen,
      salesOffices,
      queryReport,
      results,
      downloadExcel,
      formatQuantity,
      sortOptions,
      selectedSort,
      onSelectSort,
      numeral,
      searchString,
      filteredResult,
      isLoading,
    };
  },
});
</script>

<style scoped>
.driver-box .detail {
  font-size: 0.8rem;
}
</style>
